import React, { useEffect, useMemo, useState } from 'react';
import HelpLayout from './HelpLayout';
import CompanyHeader from './CompanyHeader';
import SidebarNav from './SidebarNav';
import HelpContent from './HelpContent';
import Tabs from './Tabs';
import Guide from './Guide';

type TabKey = 'guide' | 'reference';

export default function Docs() {
  const [active, setActive] = useState<TabKey>(() => {
    if (typeof window !== 'undefined' && window.location.hash === '#reference') return 'reference';
    return 'guide';
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const nextHash = active === 'reference' ? '#reference' : '#guide';
    if (window.location.hash !== nextHash) {
      window.history.replaceState(null, '', nextHash);
    }
  }, [active]);

  const tabs = useMemo(
    () => [
      { key: 'guide', label: 'Guide' },
      { key: 'reference', label: 'Reference' },
    ],
    []
  );

  const sidebarItems =
    active === 'reference'
      ? [
          { href: '#overview', label: 'Overview' },
          { href: '#views', label: 'Views' },
          { href: '#parameters', label: 'Parameters' },
          // { href: '#styling', label: 'Styling via ::part' },
          // { href: '#support', label: 'Notes' },
        ]
      : [
          { href: '#guide', label: 'Guide' },
          { href: '#embed-heading', label: 'Embed code' },
          { href: '#preview-heading', label: 'Preview' },
        ];

  return (
    <HelpLayout
      header={<CompanyHeader company="Pintar Studios" product="Web Tools" tagline="Implementation + Reference" />}
      sidebar={<SidebarNav items={sidebarItems} />}
    >
      <div className="mx-auto max-w-3xl">
        <div className="mb-4">
          <Tabs tabs={tabs} active={active} onChange={k => setActive(k as TabKey)} />
        </div>

        {active === 'guide' ? <Guide /> : <HelpContent />}
      </div>
    </HelpLayout>
  );
}
